/**
 * Created by agengmaulana on 4/28/17.
 */
import React from 'react'
import styles from './../../assets/css/prokontra_comment.css'
import {observable} from "mobx"
import {observer} from "mobx-react"

@observer
export default class Prokontra_Comment_Like_Button extends React.Component{

    @observable counter = 0
    @observable show = false
    @observable text = ''
    @observable title = ''
    @observable like = this.props.status_like

    constructor(props){
        super(props);
        this.counter = this.props.like
        this.onClickLike = this.onClickLike.bind(this);
    }

    render(){
        const {j} = this.props
        var like = this.like == 1 ? 'dk_icon-thumbs-o-up' : 'dk_icon-thumbs-up'
        return(

            <a href="javascript:void(0);" onClick={this.onClickLike.bind()} >
                <i className={styles.icon+' '+like+' '+styles.pk_like_size}></i> <span className={styles.countlk}> {this.counter}</span>
            </a>

            )
    }

    onClickLike(){

        if(this.props.dataStore.profile.id == ''){
            this.props.dataStore.configKomentar.onmasuk()

        }
        else {
            if (this.like == 0) {
                this.props.dataStore.sendLike(this.props.id,this.props.parent_id)
                this.like = 1
                this.counter++
            }
        }


    }

}


// WEBPACK FOOTER //
// ./static/src/component/prokontra_comment_like_button/prokontra_comment_like_button.js